import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { ListItem } from "@skailer-com/uikit";

export function CustomFieldListItemPercentage({
  field,
  fieldValue,
  label,
}: CustomFieldListItemProps) {
  const title = fieldValue?.value_float != null ? `${fieldValue.value_float}%` : "-";
  return <ListItem preTitle={label ?? field.title} title={title} />;
}
